import React, {useEffect, useRef} from "react";
import {gsap} from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import "./PagesHero.css";
import {SCrollDown} from "../";

gsap.registerPlugin(ScrollTrigger);

const PagesHero = ({
  subTitle,
  maskSubTitle,
  title,
  maskTitle,
  otherText1,
  maskOtherText1,
  otherText2,
  maskOtherText2,
}) => {
  const captionRef = useRef(null);
  const maskRef = useRef(null);
  const sectionRef = useRef(null);
  let isMouseMoving = false;

  useEffect(() => {
    const caption = captionRef.current;
    const mask = maskRef.current;

    const handleMouseMove = (e) => {
      if (!isMouseMoving) {
        isMouseMoving = true;
        requestAnimationFrame(() => {
          const maskRect = mask.getBoundingClientRect();
          const x = e.clientX - maskRect.left;
          const y = e.clientY - maskRect.top;

          mask.style.setProperty("--x", `${x}px`);
          mask.style.setProperty("--y", `${y}px`);
          mask.style.clipPath = `circle(120px at ${x}px ${y}px)`;

          isMouseMoving = false;
        });
      }
    };

    const handleMouseEnter = () => {
      mask.style.opacity = "1";
    };

    const handleMouseLeave = () => {
      mask.style.clipPath = `circle(0px at var(--x) var(--y))`;
      mask.style.opacity = "0";
    };

    caption.addEventListener("mousemove", handleMouseMove);
    caption.addEventListener("mouseenter", handleMouseEnter);
    caption.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      caption.removeEventListener("mousemove", handleMouseMove);
      caption.removeEventListener("mouseenter", handleMouseEnter);
      caption.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  const scrollToBottom = () => {
    if (sectionRef.current) {
      const el = sectionRef.current;
      const bottomY = el.offsetTop + el.offsetHeight;

      window.scrollTo({
        top: bottomY,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="pages-hero" ref={sectionRef}>
      <div className="hero-spotlight"></div>
      <svg aria-hidden="true" className="svg-grid">
        <defs>
          <pattern
            id="hero"
            width="80"
            height="80"
            x="50%"
            y="-1"
            patternUnits="userSpaceOnUse"
          >
            <path d="M.5 200V.5H200" fill="none"></path>
          </pattern>
        </defs>
        <rect
          width="100%"
          height="100%"
          strokeWidth="0"
          fill="url(#hero)"
          className="my-rect"
        ></rect>
      </svg>
      <div className="pages-header-inner wrap" ref={captionRef}>
        <div className="pages-caption">
          <div className="pages-caption-inner">
            <h2 className="subtitle">
              <span>{subTitle}</span>
            </h2>
            <h1 className="caption-title">{title}</h1>
            <div className="caption-description">
              <span>{otherText1}</span>
              <span>{otherText2}</span>
            </div>
          </div>
        </div>
      </div>
      {/* Mask is directly inside .pages-hero and follows wrap position */}
      <div className="pages-header-inner ph-mask" ref={maskRef}>
        <div className="mask-inner wrap">
          <div className="pages-caption">
            <div className="pages-caption-inner">
              <h2 className="subtitle">
                <span>{maskSubTitle}</span>
              </h2>
              <h1 className="caption-title">{maskTitle}</h1>
              <div className="caption-description">
                <span>{maskOtherText1}</span>
                <span>{maskOtherText2}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SCrollDown onClick={scrollToBottom} />
    </section>
  );
};

export default PagesHero;
